import { useLocation } from "react-router-dom"
import styles from "./bottom-menu.module.css"
import FarmIcon from "@/assets/icons/farm/farm-icon.tsx"
import HomeIcon from "@/assets/icons/misc/home-icon.tsx"
import { MyApiaryIcon } from "@/assets/icons/misc/my-apiary-icon.tsx"
import NewMenuIcon from "@/assets/icons/misc/new-menu-icon.tsx"
import BirdIcon from "@/assets/svg/bird-icon.svg?react"
import BottomMenuItem from "@/components/bottom-menu/bottom-menu-item/bottom-menu-item.tsx"
import NotificationsButton from "@/components/bottom-menu/notifications-button/notifications-button.tsx"
import { APIARIES_LIST_VIEW } from "@/features/bees/routes/route-list.ts"
import { BIRDS_GROUP_LIST_VIEW } from "@/features/birds-groups/routes/route-list"
import useFarmHasMammals from "@/features/farm/hooks/use-farm-has-mammals.ts"
import { FARM_VIEW } from "@/features/farm/routes/route-list.ts"
import { HOME_SCREEN } from "@/features/home/routes/route-list"
import { MENU_SCREEN } from "@/features/menu/routes/route-list.ts"
import useFarmPermissions from "@/features/permissions/hooks/use-farm-permissions.ts"
import { cn } from "@/utils/styles.ts"

function BottomMenu() {
  const location = useLocation()
  const { permissions } = useFarmPermissions()
  const isMammal = useFarmHasMammals()

  const isBeeEnabled = permissions.bee_module
  const isBirdEnabled = permissions.bird_module

  const hideNotifications = isMammal && isBeeEnabled && isBirdEnabled

  const isHome = location.pathname.includes(HOME_SCREEN)
  const isFarm = location.pathname.includes(FARM_VIEW)
  const isApiaries = location.pathname.includes(APIARIES_LIST_VIEW)
  const isBirds = location.pathname.includes(BIRDS_GROUP_LIST_VIEW)
  const isMenu = location.pathname.includes(MENU_SCREEN)

  return (
    <div className={styles.bottomMenuWrapper}>
      <div className={styles.bottomMenu}>
        <BottomMenuItem
          isActive={isHome}
          to={HOME_SCREEN}
          label="homeTab"
          alt="home"
        >
          <HomeIcon size={24} is_active={isHome} />
        </BottomMenuItem>
        {isMammal && (
          <BottomMenuItem
            isActive={isFarm}
            to={FARM_VIEW}
            label="farmTab"
            alt="farm"
          >
            <FarmIcon size={24} is_active={isFarm} />
          </BottomMenuItem>
        )}
        {isBeeEnabled && (
          <BottomMenuItem
            isActive={isApiaries}
            to={APIARIES_LIST_VIEW}
            label="apiaries"
            alt="apiaries"
          >
            <MyApiaryIcon size={24} is_active={isApiaries} />
          </BottomMenuItem>
        )}
        {isBirdEnabled && (
          <BottomMenuItem
            isActive={isBirds}
            to={BIRDS_GROUP_LIST_VIEW}
            label="birds"
            alt="birds"
          >
            <BirdIcon
              className={cn(
                "h-6 w-6 text-zinc-500",
                isBirds && "text-brown-500",
              )}
            />
          </BottomMenuItem>
        )}
        {!hideNotifications && <NotificationsButton />}
        <BottomMenuItem
          isActive={isMenu}
          to={MENU_SCREEN}
          label="menu"
          alt="menu"
        >
          <NewMenuIcon size={24} is_active={isMenu} />
        </BottomMenuItem>
      </div>
    </div>
  )
}

export default BottomMenu
